import { createContext } from "react";

interface OneRepMaxChartDataActions {
  deleteOneRepMaxById({ id }: { id: string }): void;
}

const OneRepMaxChartDataActionsContext = createContext<OneRepMaxChartDataActions | undefined>(undefined);

export default OneRepMaxChartDataActionsContext;
